module.exports = __webpack_public_path__ + "static/seo-myRedDog-e6b3d7864367f0c3abc49aa25fea0ccc.png";